import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection,APP_INITIALIZER } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { CalAngularModule, CalAngularService } from '@cvx/cal-angular';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './interceptor/http.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from '../environments/environment';
import { LoaderService } from './core/services/loader.service';
import { AppConfigService } from './services/app-config.service';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

export function initializeApp(appConfig: AppConfigService) {
  return async (): Promise<any> => {
    let appSettings = appConfig.load();
    return appSettings;
  }
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([httpInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true
    },
  
 
    CalAngularService,
    importProvidersFrom([
      CalAngularModule.forRoot(environment.calSettings)
    ]),
    provideAnimationsAsync(),
    LoaderService,
  ]
};
